<template>
  <div class="container-fluid">
    <div v-if="sNavbar">
      <NavbarHorizontal/>
      <div class="navbar_height_margin">
        <router-view/>
      </div>
    </div>
    <div v-else>
      <router-view/>
    </div>
  </div>
</template>

<script>
import NavbarHorizontal from "@/components/NavbarHorizontal.vue"

export default {
  components: {
    NavbarHorizontal
  },
  data: function () {
    return {
      sNavbar: false
    }
  },
  created: function () {
    if (this.$route.name != "login") {
      setInterval(function () { this.$store.commit("getUserProfile"); }.bind(this), 30000);
    }
  },
  computed: {
    pageTitle: function () {
      const title = this.$route.meta.title;
      let title_tranlation = null;

      if (title != null) {
        title_tranlation = this.$t(title);
        document.title = "Interní system Les Profi - " + this.$t(title);
      }

      return title_tranlation;
    },
    showNavbar: function () {
      if (this.sNavbar != null) {
        return this.sNavbar;
      }
      return true;
    }
  },
  watch: {
    // lookout for changes
    pageTitle: function () { },
    "$route.meta.navbar": {
      handler: function (val) {
        setTimeout(function () {
          this.sNavbar = this.$route.meta.navbar;
        }.bind(this), 50)
      },
      deep: true,
      immediate: false
    },
  }
}
</script>

<style lang="scss">
@import "@/scss/main.scss";
</style>